export const ButtonProps = {
  variants: {
    white: {
      height: '32px',
      width: 'auto',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      transition: 'all 0.2s ease-out',
      bg: 'white',
      color: 'solid.900',
      borderWidth: '1px',
      borderColor: 'solid.100',
      boxShadow: '0px 2px 4px -2px #00000005',

      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'white',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',

        outline: 'whites',
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'solid.100',
      },
    },
    examples: {
      height: '16px',
      width: 'auto',
      justifyContent: 'flex-start',
      borderWidth: '0px',
      bg: 'white',
      _focus: {
        borderWidth: '0px',

        outline: 'white',
      },
      _hover: {
        borderWidth: '0px',

        outline: 'white',
      },
      _active: {
        borderWidth: '0px',

        outline: 'white',
      },
      color: 'primary.100',
      textStyle: 'l-xs',
    },
    primary: {
      backgroundColor: 'primary.100',
      color: 'white',
      height: '32px',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      _focus: {
        boxShadow: '0px 0px 0px 3px rgba(93, 94, 203, 0.16)',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'primary.50',
          color: 'white',
          opacity: 0.6,
        },
      },
      _hover: {
        backgroundColor: 'primary.200',
        boxShadow: '0px 0px 0px 3px rgba(93, 94, 203, 0.12)',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'primary.50',
          color: 'white',
          opacity: 0.6,
        },
      },
      _active: {
        backgroundColor: 'primary.300',
        boxShadow: '0px 0px 0px 3px rgba(93, 94, 203, 0.20)',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'primary.50',
          color: 'white',
          opacity: 0.6,
        },
      },
      _disabled: {
        backgroundColor: 'primary.50',
        color: 'white',
        opacity: 0.6,
      },
      outline: 'none',
      border: 'none',
    },
    filter: {
      height: '32px',
      width: 'auto',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      bg: 'white',
      color: 'solid.900',
      borderWidth: '1px',
      borderColor: 'solid.100',
      boxShadow: '0px 2px 4px -2px #00000005',
      outline: 'none',

      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        borderColor: 'solid.100',
        outline: 'none',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        borderColor: 'solid.100',
        outline: 'none',
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        borderColor: 'solid.100',
        outline: 'none',
      },
    },
    invite: {
      height: '32px',
      width: 'auto',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      bg: 'white',
      color: 'primary.100',
      border: 'none',
      _focus: {
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
      _hover: {
        bg: 'primary.0',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
      _active: {
        bg: 'primary.25',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
    },
    mono: {
      backgroundColor: 'black',
      color: 'white',
      height: '32px',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      transition: 'all 0.2s ease-out',
      border: 'none',
      outline: 'none',
      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'black',
          color: 'white',
          opacity: 0.6,
        },
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'black',
          color: 'white',
          opacity: 0.6,
        },
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'black',
          color: 'white',
          opacity: 0.6,
        },
      },
      _disabled: {
        backgroundColor: 'black',
        color: 'white',
        opacity: 0.6,
      },
    },
    notSelected: {
      height: '32px',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      bg: 'white',
      color: 'solid.900',
      borderWidth: '2px',
      borderColor: 'solid.200',
      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        borderWidth: '2px',
        borderColor: 'solid.200',
        outline: 'none',
        _disabled: {
          backgroundColor: 'solid.50',
          color: 'solid.400',
          opacity: 0.6,
        },
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        borderWidth: '2px',
        borderColor: 'solid.200',
        outline: 'none',
        _disabled: {
          backgroundColor: 'solid.50',
          color: 'solid.400',
          opacity: 0.6,
        },
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        borderWidth: '2px',
        borderColor: 'solid.200',
        outline: 'none',
        _disabled: {
          backgroundColor: 'solid.50',
          color: 'solid.400',
          opacity: 0.6,
        },
      },
    },
    dropdown: {
      backgroundColor: 'white',
      color: 'solid.900',
      height: '32px',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      borderRadius: '0px',
      justifyContent: 'start',
      _focus: {
        color: 'solid.900',
        backgroundColor: 'solid.50',
        border: 'white',
        borderColor: 'white',
        outline: 'none',
      },
      _hover: {
        color: 'solid.900',
        backgroundColor: 'solid.50',
        border: 'white',
        borderColor: 'white',
        outline: 'none',
      },
      _active: {
        color: 'solid.900',
        backgroundColor: 'solid.50',
        border: 'white',
        borderColor: 'white',
        outline: 'none',
      },
    },
    delete: {
      backgroundColor: 'error.100',
      color: 'white',
      height: '32px',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      transition: 'all 0.2s ease-out',
      border: 'none',
      outline: 'none',
      _focus: {
        boxShadow: '0px 0px 0px 3px rgba(220, 38, 38, 0.16)',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'error.50',
          color: 'white',
          opacity: 0.6,
        },
      },
      _hover: {
        backgroundColor: 'error.200',
        boxShadow: '0px 0px 0px 3px rgba(220, 38, 38, 0.12)',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'error.50',
          color: 'white',
          opacity: 0.6,
        },
      },
      _active: {
        backgroundColor: 'error.300',
        boxShadow: '0px 0px 0px 3px rgba(220, 38, 38, 0.20)',
        border: 'none',
        outline: 'none',
        _disabled: {
          backgroundColor: 'error.50',
          color: 'white',
          opacity: 0.6,
        },
      },
      _disabled: {
        backgroundColor: 'error.50',
        color: 'white',
        opacity: 0.6,
      },
    },
    error: {
      height: '32px',
      width: 'auto',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      bg: 'white',
      color: 'error.200',
      borderWidth: '1px',
      borderColor: 'solid.100',
      boxShadow: '0px 2px 4px -2px #00000005',

      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
    },
    reset: {
      height: '32px',
      width: 'auto',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      bg: 'white',
      color: 'error.100',
      border: 'none',

      _focus: {
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
      _hover: {
        bg: 'error.0',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
      _active: {
        bg: 'error.25',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
    },
    default: {
      height: '32px',
      borderRadius: '24px',
      bg: 'white',
      color: 'white',
      fontSize: '12px',
      lineHeight: '14px',
      fontWeight: '510',
      borderWidth: '1px',
      borderColor: 'solid.100',
      _focus: {
        boxShadow: 'none',
        border: 'none',
        outline: 'none',
      },
      _hover: {
        boxShadow: 'none',
        border: 'none',
        outline: 'none',
      },
      _active: {
        boxShadow: 'none',
        border: 'none',
        outline: 'none',
      },
    },
    icon: {
      minWidth: '32px',
      maxWidth: '32px',
      _focus: {
        border: 'none',
        borderColor: 'none',
        outline: 'none',
      },
      _hover: {
        border: 'none',
        borderColor: 'none',
        color: '',

        outline: 'none',
      },
      _active: {
        border: 'none',
        borderColor: 'none',

        outline: 'none',
      },
      _disabled: {
        color: 'solid.400',
      },
    },
    actions: {
      borderRadius: '40px',
      px: '12px',
      py: '6px',
      gap: '4px',
      width: 'auto',
      height: '28px',
      fontWeight: '500',
      fontSize: '13px',
      lineHeight: '16px',
      color: 'solid.900',
      border: '1px',
      backgroundColor: 'white',
      borderColor: 'solid.100',
      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'white',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',

        outline: 'white',
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',

        outline: 'solid.100',
      },
    },
    calendar: {
      background: 'background.White',
      height: '55px',
      width: '40px',
      borderRadius: '12px',
      borderWidth: '1px',
      p: '8px',
      _focus: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _hover: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _active: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
    },
    pagination: {
      backgroundColor: 'background.White',

      width: '24px',
      height: '24px',
      p: '0',
      minWidth: '24px',
      minHeight: '24px',
      color: 'solid.300',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      align: 'center',
      borderRadius: '4px',
      borderWidth: '1px',

      _focus: {
        color: 'solid.900',
        backgroundColor: 'solid.50',
        // boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',

        border: 'none',
        outline: 'none',
      },
      _hover: {
        color: 'solid.900',
        backgroundColor: 'solid.50',
        // boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'none',
        outline: 'none',
      },
    },
    paginationActive: {
      width: '24px',
      height: '24px',
      minWidth: '24px',
      p: '0',
      minHeight: '24px',
      color: 'solid.900',
      backgroundColor: 'solid.50',
      // boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'none',
      outline: 'none',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      align: 'center',
      borderRadius: '4px',
      borderWidth: '1px',
    },
    normal: {
      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'solid.100',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',

        outline: 'solid.100',
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',

        outline: 'solid.100',
      },
    },
    formUtility: {
      height: '32px',
      width: 'auto',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      bg: 'white',
      color: 'solid.900',
      borderWidth: '1px',
      borderColor: 'solid.100',
      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
    },
    normalSecondary: {
      height: '32px',
      width: 'auto',
      padding: '10px 14px 10px 14px',
      gap: '8px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-out',
      bg: 'white',
      color: 'solid.900',
      borderWidth: '1px',
      borderColor: 'solid.100',
      boxShadow: '0px 2px 4px -2px #00000005',
      _focus: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
      _active: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'none',
      },
    },
    topMenu: {
      width: '100%',
      height: '40px',
      borderRadius: '8px',
      transition: 'all 0.15s ease-out',
      _focus: {
        boxShadow: 'none',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
        bg: 'primary.0',
      },
      _hover: {
        boxShadow: 'none',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
        bg: 'primary.0',
        color: 'primary.200',
      },
      _active: {
        boxShadow: 'none',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
        bg: 'primary.25',
      },
    },
    homePageCardSide: {
      width: '100%',
      height: '32px',
      _focus: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _hover: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _active: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
    },

    emojiReaction: {
      boxSize: '36px',
      minWidth: '36px',
      borderRadius: '38px',
      borderColor: 'solid.50',
      borderWidth: '1px',
      _focus: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _hover: {
        boxShadow: 'none',
        border: 'solid.50',
        borderColor: 'solid.50',
        outline: 'solid.50',
      },
    },
    noEffect: {
      borderColor: 'solid.50',
      borderRadius: '48px',
      _focus: {
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _hover: {
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _active: {
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
    },
    imageButton: {
      borderRadius: '40px',
      minWidth: '32px',
      boxSize: '32px',
      bg: 'solid.900',
      _focus: {
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _hover: {
        border: 'solid.900',
        borderColor: 'solid.900',
        outline: 'solid.900',
      },
      _active: {
        border: 'solid.900',
        borderColor: 'solid.900',
        outline: 'solid.900',
      },
    },
    playButton: {
      _focus: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _hover: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _active: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
    },
    postButton: {
      minWidth: '32px',
      boxSize: '32px',
      borderWidth: '1px',
      borderColor: 'solid.100',
      _focus: {
        boxShadow: 'none',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'white',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'solid.100',
      },
      _active: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
    },
    modalCloseButton: {
      borderColor: 'transparent',
      outline: 'none',
      borderWidth: '0',
      color: 'white',
      _focus: {
        outline: 'none',
        boxShadow: 'none',
        border: 'none',
      },
      _hover: {
        boxShadow: 'none',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
      _active: {
        boxShadow: 'none',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
      _focusVisible: {
        boxShadow: 'none',
        border: 'none',
        borderColor: 'transparent',
        outline: 'none',
      },
    },
    contentIcon: {
      minWidth: '32px',
      boxSize: '32px',
      borderWidth: '1px',
      borderColor: 'solid.100',
      _focus: {
        boxShadow: 'none',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'white',
      },
      _hover: {
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'solid.100',
      },
      _active: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
    },
    sidebarIcon: {
      minWidth: '24px',
      maxWidth: '24px',
      boxSize: '24px',
      borderColor: 'solid.100',
      _focus: {
        boxShadow: 'none',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'white',
      },
      _hover: {
        boxShadow: 'none',
        border: 'solid.100',
        borderColor: 'solid.100',
        outline: 'solid.100',
      },
      _active: {
        boxShadow: 'none',
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
    },
    hoverEffect: {
      borderColor: 'solid.50',
      borderRadius: '48px',
      _focus: {
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
      _hover: {
        border: 'solid.50',
        borderColor: 'solid.50',
        outline: 'solid.50',
        bg: 'solid.50',
      },
      _active: {
        border: 'white',
        borderColor: 'white',
        outline: 'white',
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
}
